import { Text } from '@chakra-ui/react';
import { totalAudience } from '~/screens/MediaPackDetailDefaultScreen/components/LastUpdatedPlatform/LastUpdatedPlatform.constants';

import { MetricCardData } from '../../OveriewSection.types';
import { MetricCard } from '../MetricCard';

interface Props {
  metric: MetricCardData;
  lastUpdatedComponent?: React.ReactNode;
}

export const SingleMetricCard: React.FC<Props> = ({
  metric,
  lastUpdatedComponent,
}) => (
  <MetricCard label={metric.label} tooltipInfo={metric.tooltipInfo}>
    <Text
      fontSize="6xl"
      fontWeight="medium"
      letterSpacing="wide"
      lineHeight="57px"
      marginTop={4}
    >
      {metric.value}
    </Text>
    {!totalAudience.includes(metric?.key) && lastUpdatedComponent}
  </MetricCard>
);
